import { HTTP } from '@/http-common'
import { defaultErrorHandler } from './__common.service'

function getCurrentCompany (errorHandler = defaultErrorHandler) {
  return HTTP.get('/companies').then((response) => {
    let company = response.data['results'][0]

    return HTTP.get('/companies/' + company.id).then((response) => {
      return response
    }, (err) => {
      return errorHandler(err)
    })
  })
}

function updateCurrentCompany (companyData, errorHandler = defaultErrorHandler) {
  let data = JSON.stringify(companyData)

  return HTTP.get('/companies').then((response) => {
    let company = response.data['results'][0]

    return HTTP.put('/companies/' + company.id, data, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
  })
}

export { getCurrentCompany, updateCurrentCompany }



// WEBPACK FOOTER //
// ./src/services/company.service.js